import { z } from 'zod';

export const TSDAddressSchema = z.object({
  streetAndNumber: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  postcode: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
});

export const TSDCommunicationSchema = z.object({
  phoneNumber: z.string().optional().nullable(),
  eMailAddress: z.string().optional().nullable(),
});

export const PersonSchema = z
  .object({
    identificationNumber: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    status: z.string().optional().nullable(),
    typeOfPerson: z.string().optional().nullable(),
    communication: TSDCommunicationSchema.optional(),
    address: z
      .object({
        street: z.string().optional().nullable(),
        streetAdditionalLine: z.string().optional().nullable(),
        number: z.string().optional().nullable(),
        poBox: z.string().optional().nullable(),
        subDivision: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
      })
      .optional(),
  })
  .optional();

export const AdditionalSupplyChainActorSchema = z
  .array(
    z
      .object({
        identificationNumber: z.string().optional().nullable(),
        role: z.string().optional().nullable(),
      })
      .optional(),
  )
  .optional();

export const TransportEquipmentSchema = z
  .array(
    z
      .object({
        containerIdentificationNumber: z.string().optional().nullable(),
        containerPackedStatus: z.string().optional().nullable(),
        numberOfSeals: z.string().optional().nullable(),
        seal: z
          .array(
            z
              .object({
                identifier: z.string().optional().nullable(),
              })
              .optional(),
          )
          .optional(),
      })
      .optional(),
  )
  .optional();

export const TSDCustomsOfficeSchema = z
  .object({
    referenceNumber: z.string().optional().nullable(),
  })
  .optional();

export const TSDPersonPresentingTheGoodsSchema = z
  .object({
    identificationNumber: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    address: TSDAddressSchema.optional(),
    communication: TSDCommunicationSchema.optional(),
  })
  .optional();

export const TSDCarrierSchema = z
  .object({
    name: z.string().optional().nullable(),
    identificationNumber: z.string().optional().nullable(),
  })
  .optional();
